module.exports = __webpack_public_path__ + "static/media/stackedBar.62c9d723.svg";